import { DisplayOnlyChirpContentBlockTypename } from '../../../__generated__/chirp/com/hubspot/breeze/engine/rpc/BreezeEngineStreamingService';
import { convertFieldValueAvroToJson } from 'rpc-client-utils';
import { findLastAssistantMessage } from './chatHelpers';
function isAvroFieldValue(value) {
  if (typeof value !== 'object' || value === null) return false;
  const typename = value.__typename;
  return typeof typename === 'string' && typename.startsWith('com.hubspot.chirp.ext.models.');
}
// Single pass over the last assistant message's TOOL_APPROVAL_REQUEST display
// entries, collecting both the human-readable `description` and the opaque
// `preview` JSON, each keyed by toolUseId. A single entry may carry a
// description, a preview, or both; callers read whichever map they need.
//
// Ably delivers `value` as a plain JS array; CHIRP history delivers it as an
// Avro FieldValue. Detect Avro by its chirp.ext.models __typename prefix and
// decode to plain JSON so both paths produce the same shape.
export function extractToolApprovalEntries(messages) {
  const descriptions = new Map();
  const previews = new Map();
  const lastAssistantMessage = findLastAssistantMessage(messages);
  if (!lastAssistantMessage) return {
    descriptions,
    previews
  };
  const contentBlocks = lastAssistantMessage.content;
  for (const block of contentBlocks) {
    if (block.__typename !== DisplayOnlyChirpContentBlockTypename) continue;
    const displayBlock = block;
    if (!displayBlock.value) continue;
    const rawValue = displayBlock.value;
    const decoded = isAvroFieldValue(rawValue) ? convertFieldValueAvroToJson(displayBlock.value) : rawValue;
    if (!Array.isArray(decoded)) continue;
    for (const entry of decoded) {
      if (typeof entry !== 'object' || entry === null) continue;
      const record = entry;
      if (record.entryType !== 'TOOL_APPROVAL_REQUEST' || typeof record.toolUseId !== 'string') {
        continue;
      }
      if (typeof record.description === 'string') {
        descriptions.set(record.toolUseId, record.description);
      }
      const previewValue = record.preview;
      if (previewValue !== undefined && previewValue !== null) {
        previews.set(record.toolUseId, typeof previewValue === 'string' ? previewValue : JSON.stringify(previewValue));
      }
    }
  }
  return {
    descriptions,
    previews
  };
}